package com.zi.support.shared

/**
 * Staff sign in with a username; Firebase still needs an email-shaped ID, so the apps build
 * `<username>@supportapp.internal` behind the scenes. That ID is plumbing only: it is never shown and never
 * stored as anyone's email. A support user's `email` field holds their real address, or nothing.
 */
object SupportLogin {
    const val DOMAIN = "@supportapp.internal"

    fun isLoginId(value: String?): Boolean = value?.trim()?.lowercase()?.endsWith(DOMAIN) == true

    /** [value] when it is a real address; blank for a login ID or nothing. */
    fun realEmail(value: String?): String = if (value == null || isLoginId(value)) "" else value.trim()

    /** Something to show for a stored email: the real address, or the capitalised username of a login ID. */
    fun label(value: String?): String =
        if (isLoginId(value)) value!!.trim().substringBefore('@').replaceFirstChar { it.uppercase() } else value?.trim().orEmpty()
}
